<script setup>
// Botão de discar (softphone AstraCall novo — multi-chamada/hold/transferência).
// No header da conversa. Só aparece se a caixa tem sessão AstraCall com chamadas
// habilitadas. A chamada aparece no dock global + na Central de Ligações.
import { computed, onMounted } from 'vue';
import { useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import { useAstraCalls } from 'dashboard/composables/useAstraCalls';

const props = defineProps({
  inbox: { type: Object, default: () => ({}) },
  chat: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const getters = useStoreGetters();
const { state, ensureInit, dial, sessionForInbox } = useAstraCalls();

onMounted(() => {
  const acc = getters.getCurrentAccountId.value;
  if (acc) ensureInit(acc);
});

const session = computed(() =>
  state.enabled ? sessionForInbox(props.inbox?.id) : null
);
const phone = computed(
  () =>
    props.chat?.meta?.sender?.phone_number ||
    props.chat?.meta?.sender?.identifier ||
    ''
);
const canCall = computed(() => !!session.value && !!phone.value);

const startCall = async () => {
  if (!canCall.value) return;
  try {
    await dial({
      sid: session.value.sid,
      phone: phone.value.replace(/[^\d+]/g, ''),
      conversationId: props.chat?.id,
      contactName: props.chat?.meta?.sender?.name,
    });
  } catch (e) {
    useAlert(e?.message || t('CALLS_CENTER.dock.dialError'));
  }
};
</script>

<template>
  <button
    v-if="canCall"
    v-tooltip.bottom="t('CALLS_CENTER.dock.call')"
    class="inline-flex items-center justify-center rounded-lg size-8 text-n-slate-11 hover:bg-n-alpha-1 hover:text-n-teal-11"
    @click="startCall"
  >
    <span class="i-lucide-phone-call size-5" />
  </button>
</template>
